import { getBerryWidgetStyle } from '@mindtickle/ui-shell-core/Berry';
import { getFreshchatWidgetStyle } from '@mindtickle/ui-shell-core/Freshchat';
import { isAdminSite } from '@mindtickle/utils';
import { createGlobalStyle } from 'styled-components';
import { tokens } from '@mindtickle/styles/lib';

export const ShellGlobalStyle: any = createGlobalStyle`
  ${({ featureToggles = {} }: { featureToggles: any }) =>
    !featureToggles?.isBerryChatDisabled && getBerryWidgetStyle(isAdminSite())};

  /* TODO(tech-debt) - Adding this here as we are not making any changes in ui-shell-core due to snag-error */
  /* Once we fix ui-shell-core issue, we can move this css back to getBerryWidgetStyle function */
  ${({ featureToggles = {} }: { featureToggles: any }) =>
    !featureToggles?.isBerryChatDisabled &&
    `#BerryappChatWidget iframe {
        min-height: auto !important;
        max-height: calc(100vh - 110px) !important;
        left: 16px !important;
        bottom: 16px !important;
    }
    @media screen and (max-width: 1200px) {
      #BerryappChatWidget iframe {
        max-height: 640px !important;
      }
    }
    .experience-cloud-enabled #BerryappChatWidget iframe {
      max-height: 640px !important;
    }
    #BerryappChatWidget .berry-toggle-button-container {
      visibility: hidden !important;
      }
    `};
  
  ${() => isAdminSite() && getFreshchatWidgetStyle()};
  #root .text-indigo {
    color: ${tokens.textTokens.COLOR_TEXT_ACCENT};
  }
  #root .we-btn.we-btn-try-again {
    color: ${tokens.textTokens.COLOR_TEXT_ACCENT};
    border-color: ${tokens.textTokens.COLOR_TEXT_ACCENT};
  }
  #root .page .loader-wrapper .loader-block .loader {
    border-color: ${tokens.textTokens.COLOR_TEXT_ACCENT};
  }
  #root .page[class*=" svelte-"] .btn[class*=" svelte-"] {
    background: ${tokens.bgTokens.COLOR_BG_ACCENT};
  }
  #root .page a.text-indigo:has(img[alt="View More"]):after {
    content: "\\e99d";
    font-family: 'icomoon';
    font-size: 14px;
  }

  #root .page a.text-indigo img[alt="View More"] {
      display: none;
  }

  #root .shell-layout-content-area div[data-testid="table-of-contents-menu-wrapper"] .ant-menu .ant-menu-item:hover {
    background-color: ${tokens.bgTokens.COLOR_BG_ACCENT_SUBTLE};
  }

  #splash-screen .spinner div {
    border-color: ${tokens.bgTokens.COLOR_BG_ACCENT};
  }

  #root summary .loader-wrapper[class*='svelte-'] .loader-block[class*='svelte-'] .loader {
    border-color: ${tokens.bgTokens.COLOR_BG_ACCENT} transparent transparent transparent;
  }

`;
